import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('formSubmitPanel');

    return {
        ENTER: t('enter'),
        PLEASE_CORRECT_THE_FOLLOWING: t('pleaseCorrectTheFollowing')
    };
};

export default useTranslation;
